import rpc from '@square/dashboard-utilities/clients/rpc';
import { AddressFrontendService } from '@square/dashboard-protos/models/squareup/address/service';
import { baseRpcUrl } from '@square/dashboard-utilities/utils/url';
export const COUNTRY_ADDRESS_DATA_URL = baseRpcUrl('/address/country_address_data', true);
export default AddressFrontendService.create(rpc((method, guessedUrl) => {
  switch (method) {
    case AddressFrontendService.methods.LookupCountryAddressData:
      return COUNTRY_ADDRESS_DATA_URL;
    // Use the default for any others.
    default:
      return guessedUrl;
  }
}));